import { styled } from "@mui/material/styles";
import Container from "@mui/material/Container";

const MainCustomContainer = styled(Container)(({ theme }) => ({
  paddingTop: "12rem",
  maxWidth: "90%", // Set your custom max-width
  [theme.breakpoints.up("lg")]: {
    maxWidth: "90%", // Ensure it applies for large screens or above
  },
}));

export default MainCustomContainer;
